/**
 * 事故车到店跟进
 */
import { ACCIDENTFOLLOW } from '../types';

export default {
    name: `${ACCIDENTFOLLOW}`,
    path: '/accidentFollow',
    component: () => import(/* webpackChunkName: 'accidentFollow' */ '@/views/accidentFollow/'),
    redirect: { name: `${ACCIDENTFOLLOW}Index` },
    meta: {
        title: '事故车到店跟进',
        savedPosition: { x: 0, y: 0 },
    },
    children: [
        {
            name: `${ACCIDENTFOLLOW}Index`,
            path: 'index',
            component: () => import(/* webpackChunkName: 'accidentFollow' */ '@/views/accidentFollow/home/Home.vue'),
        },

        // 二级页面示例, 没有二级页面就直接删掉
        // {
        //     name: `${ACCIDENTFOLLOW}Detail`,
        //     path: 'detail',
        //     component: () => import(/* webpackChunkName: 'accidentFollow' */ '@/views/accidentFollow/detail/Detail.vue'),
        // },
    ],
};
